import TeamPagination from "./TeamPagination";

export default TeamPagination;
